import { useQuery } from "@tanstack/react-query";
import { mediumRepository } from "../repositories/mediumRepository";

/** Shared cache entry for GET /medium/me/status. */
export const mediumStatusQueryKey = (mediumId?: string | null) =>
  ["medium", "me", "status", mediumId ?? "default"] as const;

interface UseMediumStatusQueryProps {
  mediumId?: string | null;
  enabled?: boolean;
}

/**
 * Hook to fetch the status of a specific medium.
 * The status includes whether the medium is pending approval, approved, or rejected.
 */
export const useMediumStatusQuery = ({
  mediumId,
  enabled = true,
}: UseMediumStatusQueryProps) => {
  return useQuery({
    queryKey: mediumStatusQueryKey(mediumId),
    queryFn: () => mediumRepository.getMyStatus(mediumId ?? undefined),
    enabled: enabled && !!mediumId,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
  });
};
